"use strict";

require("core-js/modules/es.array.is-array.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformProjectWebhookToJSON = exports.transformJSONToProjectWebhook = void 0;

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.set.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _projectWebhookEventEnum = require("./project-webhook-event-enum");

var _user = require("./user");

var _webhookHealthEnum = require("./webhook-health-enum");

var _webhookStatusEnum = require("./webhook-status-enum");

var _zeplinApplication = require("./zeplin-application");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var transformProjectWebhookToJSON = function transformProjectWebhookToJSON(value) {
  return {
    id: value.id,
    url: value.url,
    name: value.name,
    status: (0, _webhookStatusEnum.transformWebhookStatusEnumToJSON)(value.status),
    url_health: (0, _webhookHealthEnum.transformWebhookHealthEnumToJSON)(value.urlHealth),
    created: value.created,
    updated: value.updated,
    created_by: (0, _user.transformUserToJSON)(value.createdBy),
    updated_by: (0, _user.transformUserToJSON)(value.updatedBy),
    zeplin_app: value.zeplinApp && (0, _zeplinApplication.transformZeplinApplicationToJSON)(value.zeplinApp),
    events: _toConsumableArray(value.events).map(_projectWebhookEventEnum.transformProjectWebhookEventEnumToJSON)
  };
};

exports.transformProjectWebhookToJSON = transformProjectWebhookToJSON;

var transformJSONToProjectWebhook = function transformJSONToProjectWebhook(value) {
  return {
    id: value.id,
    url: value.url,
    name: value.name,
    status: (0, _webhookStatusEnum.transformJSONToWebhookStatusEnum)(value.status),
    urlHealth: (0, _webhookHealthEnum.transformJSONToWebhookHealthEnum)(value.url_health),
    created: value.created,
    updated: value.updated,
    createdBy: (0, _user.transformJSONToUser)(value.created_by),
    updatedBy: (0, _user.transformJSONToUser)(value.updated_by),
    zeplinApp: value.zeplin_app && (0, _zeplinApplication.transformJSONToZeplinApplication)(value.zeplin_app),
    events: new Set(value.events.map(_projectWebhookEventEnum.transformJSONToProjectWebhookEventEnum))
  };
};
/**
 * 
 * @export
 * @interface ProjectWebhook
 */


exports.transformJSONToProjectWebhook = transformJSONToProjectWebhook;